export default function ContactFooter() {
  return (
    <footer
      className="relative w-full bg-secondary-100 overflow-hidden"
      style={{ paddingTop: '100px', paddingBottom: '100px' }}
      aria-label="Contact information"
      role="contentinfo"
    >
      <div className="relative mx-4 md:mx-6 max-w-[90%] md:max-w-[90%] mx-auto rounded-[32px] bg-background-50 px-8 md:px-16 py-20 md:py-[80px]">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-[40%]">
            <h4
              className="text-xs font-medium uppercase tracking-[0.08em] text-foreground-500 mb-8"
              style={{ fontFamily: 'var(--font-body)' }}
            >
              Contact
            </h4>

            <address className="not-italic">
              <p
                className="text-sm leading-[1.8] text-foreground-700"
                style={{ fontFamily: 'var(--font-body)', fontWeight: 300 }}
              >
                71 Patterson Street South
                <br />
                Sudbury
                <br />
                P3C2J3
                <br />
                Canada
              </p>

              <div className="mt-6 space-y-1">
                <p
                  className="text-sm text-foreground-700"
                  style={{ fontFamily: 'var(--font-body)', fontWeight: 300 }}
                >
                  +1 7058065512
                </p>
                <p
                  className="text-sm text-foreground-700"
                  style={{ fontFamily: 'var(--font-body)', fontWeight: 300 }}
                >
                  info@vaskosolutions.com
                </p>
              </div>
            </address>
          </div>

          <div className="hidden md:block w-[60%]" />
        </div>
      </div>

      <div
        className="absolute -left-[120px] top-1/2 -translate-y-1/2 w-[200px] h-[300px] bg-primary-800 rounded-[24px] hidden md:block"
        style={{ transform: 'translateY(-50%) rotate(-12deg)' }}
        aria-hidden="true"
      />
      <div
        className="absolute -right-[120px] bottom-1/4 w-[160px] h-[260px] bg-primary-800/70 rounded-[24px] hidden md:block"
        style={{ transform: 'rotate(12deg)' }}
        aria-hidden="true"
      />
    </footer>
  );
}